import { useApi, useAuth } from '../../hooks';
import { useQuery } from '@tanstack/react-query';

export const useUserSymptom = (userId?: string) => {
  const { api } = useApi();
  const { isAuthenticated, loading, userToken } = useAuth();

  const fetchUserSymptom = async () => {
    const requestObj = {
      route: `/private/user-symptom/?user_id=${userId}`,
      token: userToken,
    };

    return await api(requestObj);
  };

  const { data, isLoading, isError } = useQuery<any, Error>({
    queryKey: ['hc-user-symptom', userToken, userId],
    queryFn: () => fetchUserSymptom(),
    enabled: !!userId && isAuthenticated && !loading && !!userToken,
    refetchOnWindowFocus: false,
  });

  return { data, isLoading, isError };
};
